var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"classify"},[_c('img',{staticClass:"classify-icon",attrs:{"src":_vm.iconSrc,"alt":""}}),_c('div',{staticClass:"classify-name"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }